import { render, staticRenderFns } from "./filingManagementPersonnelNew.vue?vue&type=template&id=40646a25&scoped=true"
import script from "./filingManagementPersonnelNew.vue?vue&type=script&lang=js"
export * from "./filingManagementPersonnelNew.vue?vue&type=script&lang=js"
import style0 from "./filingManagementPersonnelNew.vue?vue&type=style&index=0&id=40646a25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40646a25",
  null
  
)

export default component.exports